/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { createRoot } from "react-dom/client";
import "rxjs";
import { Provider } from "react-redux";
import { applyRouterMiddleware, IndexRoute, Router, Route } from "react-router";
import useScroll from "react-router-scroll/lib/useScroll";

import store, { history } from "./store";
import {
  requireAuth,
  onlyNotAuthenticated,
  requireAdminAuth,
  requireSuperAdminAuth,
} from "./utils/authChecker";
import { updateDocumentSeo } from "./utils/seo";
import { trackPageView } from "./utils/trackingConsent";

import App from "./containers/App";
import AboutUs from "./components/about-us/AboutUs";
import AboutUsBeta from "./components/about-us-beta3/AboutUsBeta";

import BrandService from "./components/brand-service/BrandService";
import Careers from "./components/careers/Careers";
import CareersPost from "./components/careers/CareersPost";
import Onboard from "./components/onboard/Onboard";
import Hatchway from "./components/onboard/Hatchway";
// start Careers
import BizDevDirector from "./components/careers/BizDevDirector";
import CampaignManager from "./components/careers/CampaignManager";
import UXIndi from "./components/careers/UXIndi";
import BrandSalesManager from "./components/careers/BrandSalesManager";

// added April 2, 2021
import CommunityManager from "./components/careers/CommunityManager";

// End Careers

import Contact from "./components/contact/Contact";
import SearchLight from "./components/searchLight/SearchLight";
import SignIn from "./components/login/sign-in/SignIn";
import SignUp from "./components/login/sign-up/SignUp";
import CompleteRegistration from "./components/login/complete-registration/CompleteRegistration";
import Recover from "./components/login/recover/Recover";
import ConnectAccounts from "./components/connect-accounts/ConnectAccounts";
import Logout from "./components/logout/Logout";
import LogOutBooth from "./components/logout/LogOutBooth";
import FAQ from "./components/faq/Faq";
import Log from "./components/admin/logs/Log";
import StreamerPackage from "./components/admin/user/StreamerPackageManager";

import NotFound from "./components/not-found/NotFound";
import AccessDenied from "./components/access-denied/AccessDenied";

import GameNew from "./components/game/GameNew";
// 兑换页面相关组件
// import ExchangePage from './components/exchange/ExchangePage';
// 管理员兑换中心
// import ExchangeCenter from './components/admin/exchange-center/ExchangeCenter';
// GameFeatured

import "normalize.css";
import "./reset.scss";
import "./index.scss";

import Welcome from "./components/welcome/Welcome";
import WhatsNoiz from "./components/whats-noiz/WhatsNoiz";

import Profile from "./components/profile/Profile";
import MyQuestsPage from "./components/my-quests-page/MyQuestsPage";
import QuestDetailPage from "./components/dashboard/quest-detail/QuestDetailPage";
import DropsPage from "./components/drops/DropsPage";
import DropsLinkPage from "./components/drops/DropsLinkPage";
import DropsLinkStartPage from "./components/drops/DropsLinkStartPage";

import CommandCenter from "./components/admin/command-center/CommandCenter";
import GameKeys from "./components/admin/command-center/game-keys/GameKeys";
import TrackedLinks from "./components/admin/command-center/tracked-links/TrackedLinks";

import WhiteList from "./components/admin/command-center/white-list/WhiteList";
import Quest from "./components/quest/Quest";
import QuestIndexNew from "./components/quests/QuestIndexNew";
import ProductManagementContainer from "./containers/ProductManagementContainer";
import Quests from "./components/admin/command-center/quests/Quests";
import QuestEdit from "./components/admin/command-center/quest-edit/QuestEdit";
import QuestActivity from "./components/admin/command-center/quest-activity/QuestActivity";
import QuestSales from "./components/admin/command-center/quest-sales/QuestSales";
import QuestTimed from "./components/admin/command-center/quest-timed-activity/QuestTimedActivity";
import QuestPreapproval from "./components/admin/command-center/quest-preapproval/QuestPreapproval";
import QuestAffiliateActivity from "./components/admin/command-center/quest-affiliate-activity/QuestAffiliateActivity";
import QuestTieredActivity from "./components/admin/command-center/quest-tiered/QuestTiered";
import QuestTieredMultipleDaysActivity from "./components/admin/command-center/quest-tiered-multiple-days/QuestTieredMultipleDays";

import Campaigns from "./components/admin/command-center/campaigns/Campaigns";
import CampaignEdit from "./components/admin/command-center/campaign-edit/CampaignEdit";

// import AdminUserList from "./components/admin/user/list/UserList";
import AdminUserContainer from "./components/admin/user/AdminUserContainer";
import AdminUserCreate from "./components/admin/user/create/UserCreate";
import AdminUserBrandCreate from "./components/admin/user/create/UserBrandCreate";
import AdminUserEdit from "./components/admin/user/edit/UserEdit";

import AnnouncementManagement from "./components/admin/announcement/AnnouncementManagement";

import AdminGameList from "./components/admin/game/list/GameList";
import AdminGameCreate from "./components/admin/game/create/GameCreate";
import AdminGameEdit from "./components/admin/game/edit/GameEdit";
import AdminGameFeatured from "./components/admin/game/featured/GameFeatured";
import AdminSetGames from "./components/admin/game/set/SetGames";

import AdminCustomGraph from "./components/admin/custom/Graph";

// import AdminPaymentList from './components/admin/payment/list/PaymentList';
import PaymentContainer from "./components/admin/payment/PaymentContainer";

import Portal from "./components/brand/portal/Portal";
import PortalSignForm from "./components/brand/portal/PortalSignForm";

import StorefrontGame from "./components/storefront/storefront-game/StorefrontGame";
import StorefrontSuccess from "./components/storefront/storefront-game/Success";
import StorefrontCheckout from "./components/storefront/storefront-game/Checkout";

import SearchGames from "./components/search-games/SearchGames";
import SearchQuests from "./components/search-quests/SearchQuests";

import ContactLight from "./components/brand/contact/ContactLight";
import Contacts from "./components/admin/contacts/Contacts";

import DataForm from "./components/data-form/DataForm";

import Insights from "./components/admin/insights/Insights";
import PaypalButton from "./components/admin/PaypalButton";
import {
  WithdrawalComponent,
  PayoutComponent,
  PaymentComponent,
} from "./components/admin/WithdrawalComponent";
// import PaymentComponent from './components/admin/PaymentComponent';
// import PayPalDashboard from './components/admin/PayPalDashboard';
import TwitchComponent from "./components/admin/twitch";

import LandingQuest from "./components/landing-quest/LandingQuest";
import OffplatformQuest from "./components/offplatform-quest/OffplatformQuest";

import DnlReferralSalesTermsConditions from "./components/static-pages/DnlReferralSalesTermsConditions";
import DnlKeyQuestTermsConditions from "./components/static-pages/DnlKeyQuestTermsConditions";
import DnlReferralSalesAgreement from "./components/static-pages/DnlReferralSalesAgreement";

import AdminDashboard from "./components/my-account/admin-dashboard/AdminDashboard";
import AdminImportUsers from "./components/my-account/admin-import-users/AdminImportUsers";
import PrivacyPolicy from "./components/static-pages/PrivacyPolicy";
import PrivacyPolicyUpdate from "./components/static-pages/PrivacyPolicyUpdate";

import TermsOfUse from "./components/static-pages/TermsOfUse";
import TermsOfService from "./components/static-pages/TermsOfService";
import QuestParticipationAgreement from "./components/static-pages/QuestParticipationAgreement";

// import DinamicComponents from './components/DinamicComponent';

import MaintenanceMode from "./components/maintenance-mode/MaintenanceMode";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import Arbitration from "./components/admin/command-center/arbitration/Arbitration";

import Home from "./components/home/Home";
import SearchLightGameInfo from "./components/searchLight/SearchLightGameInfo";
import Wallet from "./components/profile/Wallet";
import WithDraw from "./components/profile/WithDraw";
import WithDrawInst from "./components/profile/WithDrawInst";
import Transaction from "./components/profile/Transaction";
// import UserProductSales from "./components/profile/UserProductSales";
import BuyCDK from "./components/product-sales/BuyCDK";
import ConfigurationCenter from "./components/admin/configuration-center/ConfigurationCenter";
import CDKeys from "./components/admin/command-center/game-keys/CDKeys";
import CDKInfo from "./components/profile/CDKInfo";
import PermissionCenter from "./components/admin/configuration-center/PermissionCenter";
import AdminCenter from "./components/admin/configuration-center/AdminCenter";
import QuestAuditContainer from "./components/admin/quest/QuestAuditContainer";
import SteamTestPage from "./components/admin/steam/SteamTestPage";

// import TestPage from './components/test-page/TestPage';
import DouyinCallback from "./components/test-page/DouyinCallback";
import TopTankAdmin from "./components/top-tank/TopTankAdmin";

import {
  patchFetchForPrerender,
  safeFetchJson,
  isPrerender,
} from "./utils/prerender";
import { bootstrapLegacySession } from "./utils/sessionBootstrap";
import TwitchDrop from "./components/admin/command-center/twitch-drop/TwitchDrop";
import TwitchDropEdit from "./components/admin/command-center/twitch-drop-edit/TwitchDropEdit";
import TwitchDropUser from "./components/twitch-drop/TwitchDrop";

// Patch fetch early when running under prerender (react-snap) to avoid network failures
patchFetchForPrerender();

// During prerender runs, suppress noisy console output (keep warn/error)
if (typeof window !== "undefined" && isPrerender()) {
  console._original_log = console._original_log || console.log;
  console._original_debug = console._original_debug || console.debug;
  console.log = () => {};
  console.debug = () => {};
}

const routeList = {
  // should be converted to env var or db config number
  "/quests": 0.4,
  "/admin/command-center/": 0.1,
  "/": 0.2,
};

// Sentry.io Config
const { NODE_ENV } = process.env;
const isAliveEnv = NODE_ENV === "production" || NODE_ENV === "staging";
if (isAliveEnv) {
  Sentry.init({
    dsn: "https://35f5ae7971a942408360de3487b7056f@o140475.ingest.sentry.io/702046",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampler: (samplingContext) => {
      const { NODE_ENV, SENTRY_DEFAULT_RATE } = process.env;
      if (NODE_ENV !== "production") return 0;
      const defaultPassthrough = SENTRY_DEFAULT_RATE
        ? parseFloat(SENTRY_DEFAULT_RATE)
        : 0;
      const { pathname } = samplingContext.location;
      const presetPassthrough = routeList[pathname] ? routeList[pathname] : 0;
      return presetPassthrough || defaultPassthrough;
    },
  });
}

const scrollMidleware = useScroll(
  (prevRouterProps, { location }) =>
    prevRouterProps && location.pathname !== prevRouterProps.location.pathname,
);

history.listen((location) => {
  updateDocumentSeo(location);
  trackPageView(location);
});

updateDocumentSeo({
  pathname: window.location.pathname,
  search: window.location.search,
});

const subdomain = window.location.host
  .split(":")[0]
  .split(".")
  .slice(0, -2)
  .join(".");

const router = (
  <Provider store={store}>
    <Router history={history} render={applyRouterMiddleware(scrollMidleware)}>
      <Route path="/" component={App}>
        <IndexRoute component={BrandService} />
        {/* No subdomain and www subdomain routes here! */}
        {/* { (subdomain === '' || subdomain === 'www' || subdomain === 'staging' || subdomain === 'new' || subdomain === '10.32' || subdomain === 'staging-v2' || subdomain === 'prod') && */}
        <React.Fragment>
          <Route
            path="/store"
            onEnter={() => {
              window.location.replace("https://store.noiz.gg/");
            }}
            component={() => null}
          />
          <Route
            path="/portal/sign-in"
            component={(props) => <PortalSignForm {...props} signInPage />}
            onEnter={onlyNotAuthenticated()}
          />
          <Route
            path="/portal/sign-up"
            component={PortalSignForm}
            onEnter={onlyNotAuthenticated()}
          />
          <Route
            path="/portal"
            component={Portal}
            onEnter={requireAuth([
              "brand",
              "admin",
              "demo",
              "helper",
              "finance",
              "sadmin",
            ])}
          />
          <Route
            path="/sign-up(/:back/:rel)"
            component={SignUp}
            onEnter={onlyNotAuthenticated()}
          />
          <Route
            path="/sign-in(/:back/:rel)"
            component={SignIn}
            onEnter={onlyNotAuthenticated()}
          />
          <Route
            path="/recover"
            component={Recover}
            onEnter={onlyNotAuthenticated()}
          />
          <Route path="/logout" component={Logout} />
          <Route path="/logout-booth" component={LogOutBooth} />
          <Route
            path="/connect-accounts(/:platform)"
            component={ConnectAccounts}
            onEnter={requireAuth([
              "user",
              "admin",
              "helper",
              "finance",
              "sadmin",
            ])}
          />
          <Route
            path="/complete-registration"
            component={CompleteRegistration}
            onEnter={requireAuth([
              "user",
              "admin",
              "helper",
              "demo",
              "finance",
              "sadmin",
            ])}
          />
          <Route
            path="/welcome"
            component={Welcome}
            onEnter={requireAuth([
              "user",
              "admin",
              "helper",
              "demo",
              "finance",
              "sadmin",
            ])}
          />
          <Route path="/access-denied" component={AccessDenied} />
          <Route
            path="/buy/:gameSlug/:questSlug/:username"
            component={StorefrontGame}
          >
            <Route
              path="/buy/:gameSlug/:questSlug/:username/success"
              component={StorefrontSuccess}
            />
            <Route
              path="/buy/:gameSlug/:questSlug/:username/checkout"
              component={StorefrontCheckout}
            />
          </Route>
          <Route path="/buy/:gameSlug" component={StorefrontGame}>
            <Route
              path="/buy/:gameSlug/success"
              component={StorefrontSuccess}
            />
            <Route
              path="/buy/:gameSlug/checkout"
              component={StorefrontCheckout}
            />
          </Route>
          <Route path="/quests/:questId" component={Quest} />
          <Route
            path="/quests/:questSlug/:userId"
            component={OffplatformQuest}
          />
          <Route path="/quest/:questSlug" component={LandingQuest} />
          {/* <Route path="/login" component={TwitchLogin} onEnter={onlyNotAuthenticated()} /> */}
          <Route
            path="/twitch"
            component={TwitchComponent}
            onEnter={requireAuth(["admin", "finance", "sadmin"])}
          />
          {/* <Route path="/youtube" component={TestPage} /> */}
          <Route path="/test" component={DouyinCallback} />
          {/*在 Route path="/admin 相关部分添加新路由*/}
          <Route
            path="/admin/quest/audit"
            component={QuestAuditContainer}
            onEnter={requireAdminAuth("CommandCenter")}
          />
          <Route
            path="/admin/steam"
            component={SteamTestPage}
            onEnter={requireAdminAuth("CommandCenter")}
          />
          <Route
            component={QuestIndexNew}
            onEnter={requireAuth([
              "user",
              "admin",
              "helper",
              "demo",
              "finance",
              "sadmin",
            ])}
            path="/quests"
          />
          <Route
            component={ProductManagementContainer}
            onEnter={requireAuth([
              "user",
              "admin",
              "helper",
              "demo",
              "finance",
              "sadmin",
            ])}
            path="/product-management"
          />
          <Route
            path="/game/:gameId"
            component={GameNew}
            // onEnter={requireAuth(['user', 'admin', 'helper', 'demo', 'finance', 'sadmin'])}
          />
          {/* 兑换页面路由 */}
          {/* <Route
            path="/exchange"
            component={ExchangePage}
          /> */}
          <Route
            path="/search/games"
            component={SearchGames}
            onEnter={requireAuth([
              "user",
              "admin",
              "helper",
              "demo",
              "finance",
              "sadmin",
            ])}
          />
          <Route
            path="/search/quests"
            component={SearchQuests}
            onEnter={requireAuth([
              "user",
              "admin",
              "helper",
              "demo",
              "finance",
              "sadmin",
            ])}
          />
          {/* <Route path="/game/:gameId/get-key" component={GameGetKey} />
          <Route path="/game/:gameId/join-bounty" component={GameJoinBounty} />
          <Route path="/profile" component={Profile} onEnter={requireAuth(['user', 'admin'])} /> */}
          <Route
            path="/my-account"
            component={Profile}
            onEnter={requireAuth([
              "brand",
              "user",
              "admin",
              "helper",
              "demo",
              "finance",
              "sadmin",
            ])}
          >
            {/*<IndexRoute component={MyAccountHome} />*/}
          </Route>
          <Route
            path="/my-account-detail"
            component={Profile}
            onEnter={requireAuth(["user", "admin", "finance", "sadmin"])}
          >
            <Route path="/my-account-detail/wallet" component={Wallet} />
            <Route path="/my-account-detail/withdraw" component={WithDraw} />
            <Route
              path="/my-account-detail/transaction-record"
              component={Transaction}
            />
          </Route>
          <Route
            path="/my-account-cdk"
            component={Profile}
            onEnter={requireAuth(["user", "admin", "finance", "sadmin"])}
          ></Route>
          <Route
            path="/account/store"
            component={Profile}
            onEnter={requireAuth(["user", "admin", "finance", "sadmin"])}
          />
          <Route path="/buy-cdk/:productId" component={BuyCDK} />
          <Route path="/withdraw-instructions" component={WithDrawInst} />
          <Route path="/cdk-view/:orderId" component={CDKInfo} />
          <Route path="/drops/link" component={DropsLinkPage} />
          <Route path="/drops/link/start" component={DropsLinkStartPage} />
          <Route
            path="/drops"
            component={DropsPage}
            onEnter={requireAuth([
              "user",
              "admin",
              "helper",
              "demo",
              "finance",
              "sadmin",
            ])}
          />
          <Route
            path="/my-quests"
            component={MyQuestsPage}
            onEnter={requireAuth([
              "user",
              "admin",
              "helper",
              "demo",
              "finance",
              "sadmin",
            ])}
          />
          <Route
            path="/my-quests/:questId"
            component={QuestDetailPage}
            onEnter={requireAuth([
              "user",
              "admin",
              "helper",
              "demo",
              "finance",
              "sadmin",
            ])}
          >
            <Route
              path="/my-quests/:questId/statistics"
              component={QuestDetailPage}
            />
            <Route
              path="/my-quests/:questId/requirements"
              component={QuestDetailPage}
            />
          </Route>
          <Route
            path="/my-quests/preview/:questId"
            component={QuestDetailPage}
            onEnter={requireAdminAuth("CommandCenter")}
          />
          <Route
            path="/my-quests/preview/:questId/requirements"
            component={QuestDetailPage}
            onEnter={requireAdminAuth("CommandCenter")}
          />
          <Route
            path="/my-quests/preview/:questId/statistics"
            component={QuestDetailPage}
            onEnter={requireAdminAuth("CommandCenter")}
          />
          {/* Admin Sections */}
          <Route
            path="/admin/import/users"
            component={AdminImportUsers}
            onEnter={requireAdminAuth("Users")}
          />
          <Route
            path="/admin/report/:gameId"
            component={AdminDashboard}
            onEnter={requireAdminAuth("CommandCenter")}
          />
          <Route
            path="/admin/custom/graph/:id"
            component={AdminCustomGraph}
            onEnter={requireAdminAuth("CommandCenter")}
          />
          {/* 管理员兑换中心路由 */}
          {/* <Route
            path="/admin/exchange-center"
            component={ExchangeCenter}
            onEnter={requireAdminAuth('')}
          /> */}
          <Route
            path="/admin/command-center"
            component={CommandCenter}
            onEnter={requireAdminAuth("")}
          >
            <Route path="/admin/command-center/:gameId">
              <Route
                path="/admin/command-center/:gameId/keys"
                component={GameKeys}
              />
              <Route
                path="/admin/command-center/:gameId/links"
                component={TrackedLinks}
              />
              <Route
                path="/admin/command-center/:gameId/white-list"
                component={WhiteList}
              />
              <Route
                path="/admin/command-center/:gameId/quests"
                component={Quests}
              />
              <Route
                path="/admin/command-center/:gameId/quests/create"
                component={QuestEdit}
              />
              <Route
                path="/admin/command-center/:gameId/quests/:questId/edit"
                component={QuestEdit}
              />
              <Route
                path="/admin/command-center/:gameId/quests/:questId/activity"
                component={QuestActivity}
              />
              <Route
                path="/admin/command-center/:gameId/quests/:questId/sales"
                component={QuestSales}
              />
              <Route
                path="/admin/command-center/:gameId/quests/:questId/timed"
                component={QuestTimed}
              />
              <Route
                path="/admin/command-center/:gameId/quests/:questId/preapproval"
                component={QuestPreapproval}
              />
              <Route
                path="/admin/command-center/:gameId/twitch-drop"
                component={TwitchDrop}
              />
              <Route
                path="/admin/command-center/:gameId/twitch-drop/create"
                component={TwitchDropEdit}
              />
              <Route
                path="/admin/command-center/:gameId/twitch-drop/:twitchDropId/edit"
                component={TwitchDropEdit}
              />
              <Route
                path="/admin/command-center/:gameId/quests/:questId/affiliate"
                component={QuestAffiliateActivity}
              />
              <Route
                path="/admin/command-center/:gameId/quests/:questId/:questType"
                component={QuestTieredActivity}
              />
              <Route
                path="/admin/command-center/:gameId/quests/:questId/tiered-multiple-days"
                component={QuestTieredMultipleDaysActivity}
              />
              <Route
                path="/admin/command-center/:gameId/campaigns"
                component={Campaigns}
              />
              <Route
                path="/admin/command-center/:gameId/campaigns/create"
                component={CampaignEdit}
              />
              <Route
                path="/admin/command-center/:gameId/campaigns/:campaignId/edit"
                component={CampaignEdit}
              />
              <Route
                path="/admin/command-center/:gameId/sell"
                component={CDKeys}
              />
            </Route>
          </Route>
          <Route
            path="/admin/users"
            component={AdminUserContainer}
            onEnter={requireAdminAuth("Users")}
          />
          <Route
            path="/admin/users/create"
            component={AdminUserCreate}
            onEnter={requireAdminAuth("Users")}
          />
          <Route
            path="/admin/users/create-brand"
            component={AdminUserBrandCreate}
            onEnter={requireAdminAuth("Users")}
          />
          <Route
            path="/admin/users/edit/:userId"
            component={AdminUserEdit}
            onEnter={requireAdminAuth("Users")}
          />
          <Route
            path="/admin/announcements"
            component={AnnouncementManagement}
            onEnter={requireAdminAuth("Users")}
          />
          <Route
            path="/admin/games"
            component={AdminGameList}
            onEnter={requireAdminAuth("Games")}
          />
          {/* <Route path="/admin/games/create" component={AdminGameEdit} onEnter={requireAuth(['admin'])} /> */}
          <Route
            path="/admin/games/create"
            component={AdminGameCreate}
            onEnter={requireAdminAuth("Games")}
          />
          <Route
            path="/admin/games/edit/:gameId"
            component={AdminGameEdit}
            onEnter={requireAdminAuth("Games")}
          />
          <Route
            path="/admin/games/featured"
            component={AdminGameFeatured}
            onEnter={requireAdminAuth("Games")}
          />
          <Route
            path="/admin/games/set"
            component={AdminSetGames}
            onEnter={requireAdminAuth("Games")}
          />
          <Route
            path="/admin/insights"
            component={Insights}
            onEnter={requireAdminAuth("CommandCenter")}
          />
          <Route
            path="/admin/arbitration"
            component={Arbitration}
            onEnter={requireAdminAuth("CommandCenter")}
          />
          <Route
            path="/admin/contacts"
            component={Contacts}
            onEnter={requireAdminAuth("CommandCenter")}
          />
          <Route
            path="/admin/payments"
            component={PaymentContainer}
            onEnter={requireAdminAuth(["Transactions", "ApproveWithdrawals"])}
          />
          <Route
            path="/withdrawal"
            component={WithdrawalComponent}
            onEnter={requireAdminAuth("ApproveWithdrawals")}
          />
          <Route
            path="/payout"
            component={PayoutComponent}
            onEnter={requireAdminAuth("ApproveWithdrawals")}
          />
          <Route
            path="/paypal"
            component={PaypalButton}
            onEnter={requireAdminAuth("ApproveWithdrawals")}
          />
          {/* <Route path="/paybutton" component={PaymentComponent} onEnter={requireAuth(['admin', 'sadmin'])} />   */}
          <Route
            path="/payment"
            component={PaymentComponent}
            onEnter={requireAdminAuth("ApproveWithdrawals")}
          />
          {/* <Route path="/paydas" component={PayPalDashboard} onEnter={requireAuth(['admin', 'sadmin'])} />      */}
          {/*
          <Route path="/admin/config" component={AdminConfigList} onEnter={requireAuth(['admin'])} />
          <Route path="/admin/config/create" component={AdminConfigCreate} onEnter={requireAuth(['admin'])} />
          <Route path="/admin/config/edit/:configId" component={AdminConfigEdit} onEnter={requireAuth(['admin'])} />
          */}
          <Route
            path="/dnl-referral-sales-terms-conditions"
            component={DnlReferralSalesTermsConditions}
          />
          <Route
            path="/dnl-key-quest-terms-conditions"
            component={DnlKeyQuestTermsConditions}
          />
          <Route
            path="/dnl-referral-sales-agreement"
            component={DnlReferralSalesAgreement}
          />
          {/* Plain Info Pages */}
          <Route path="/faqs" component={FAQ} />
          <Route
            path="/logs"
            component={Log}
            onEnter={requireAdminAuth("Logs", "")}
          />
          <Route
            path="/streamer"
            component={StreamerPackage}
            onEnter={requireAdminAuth("Users", "")}
          />
          <Route
            path="/whats-noiz"
            component={WhatsNoiz}
            // onEnter={requireAuth(['user', 'admin', 'helper', 'demo', 'finance', 'sadmin'])}
          />
          {/* <Route path="/brand-services" component={BrandService} /> */}
          <Route path="/about-us-beta3" component={AboutUsBeta} />
          <Route path="/stream-with-us" component={Home} />
          {/* TopTank / TopRank integration */}
          <Route path="/top-tank/admin(/:tab)" component={TopTankAdmin} />
          <Route path="/careers" component={Careers} />
          <Route
            path="/careers/business-development-representative"
            component={CareersPost}
          />
          <Route path="/careers/biz-dev-director" component={BizDevDirector} />
          <Route
            path="/careers/community-manager"
            component={CommunityManager}
          />
          <Route path="/careers/campaign-manager" component={CampaignManager} />
          <Route path="/careers/ux-ev" component={UXIndi} />
          <Route
            path="/careers/brand-sales-manager"
            component={BrandSalesManager}
          />
          <Route path="/onboard" component={Onboard} />
          <Route path="/brand/hatchway" component={Hatchway} />
          <Route path="/contact" component={Contact} />
          <Route path="/searchlight" component={SearchLight} />
          <Route
            path="/searchlight/game/:gameId"
            component={SearchLightGameInfo}
          />
          <Route path="/about-us" component={AboutUs} />){/* Trade Show Page */}
          <Route
            path="/admin/ConfigurationCenter"
            component={ConfigurationCenter}
            onEnter={requireSuperAdminAuth()}
          />
          <Route
            path="/admin/PermissionCenter"
            component={PermissionCenter}
            onEnter={requireSuperAdminAuth()}
          />
          <Route
            path="/admin/AdminCenter"
            component={AdminCenter}
            onEnter={requireSuperAdminAuth}
          />
          <Route path="/twitch-drop/:identifier" component={TwitchDropUser} />
        </React.Fragment>
        {/* Brands subdomain routes here! */}
        {(subdomain === "brands" || subdomain === "staging.brands") && (
          <React.Fragment>
            <Route path="/contact" component={ContactLight} />
          </React.Fragment>
        )}
        {/* Fractured Lands subdomain routes here! */}
        {(subdomain === "fractured-lands-partners" ||
          subdomain === "staging.fractured-lands-partners") && (
          <React.Fragment>
            <Route path="/signup" component={DataForm} />
          </React.Fragment>
        )}
        {/* Shared Subdomain Routes */}
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/terms-of-use" component={TermsOfUse} />
        <Route path="/privacy-policy-update" component={PrivacyPolicyUpdate} />
        <Route path="/terms-of-service" component={TermsOfService} />
        <Route
          path="/quest-participation-agreement"
          component={QuestParticipationAgreement}
        />
        <Route path=":slug*" component={NotFound} />
      </Route>
    </Router>
  </Provider>
);
const rootEl = document.getElementById("root");
const root = createRoot(rootEl);
const renderApp = (element) => root.render(element);

// 在 React 渲染前同步拦截 /store，避免闪烁
if (
  window.location.pathname === "/store" ||
  window.location.pathname.startsWith("/store/")
) {
  window.location.replace("https://store.noiz.gg/");
}

async function getMaintenanceMode() {
  try {
    const res = await safeFetchJson("/api/v1/maintenance-mode/");
    const value = res && res[0] && res[0].value;
    if (value) renderApp(<MaintenanceMode />);
    else renderApp(router);
  } catch (err) {
    // If safeFetchJson returns null or throws, continue to render the app.
    // eslint-disable-next-line no-console
    console.error("getMaintenanceMode failed", err && err.message);
    renderApp(router);
  }
}

async function bootstrapAndRender() {
  if (!isPrerender()) {
    await bootstrapLegacySession({ store });
  }

  await getMaintenanceMode();
}

bootstrapAndRender();
